import * as jf from 'joiful';
import { AccountAddressDto } from '../account-addresses/account-address.dto';
import { CaseHeaderModel } from './case-header.model';
import { CaseLineModel } from './case-line.model';
import { CasePickupDto } from './case-pickup.dto';
import { CaseReturnRequestType } from './case-return-request.enum';

export class CaseModel extends CaseHeaderModel {
  @jf.array()
  public lines: CaseLineModel[];

  @(jf.object().optional())
  public pickup?: CasePickupDto;

  @(jf.string().optional())
  public requestType?: CaseReturnRequestType;

  @(jf.number().optional())
  parcelCount: number;

  @(jf.number().optional())
  palletCount: number;

  @(jf.object().optional())
  public address?: AccountAddressDto;
}
